import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}

      <section className="hero">
        <h1>🚀 Find Your Dream Job Today!</h1>
        <p>Browse thousands of jobs, get expert career advice, and upskill for your future.</p>
        <Link to="/jobs" className="btn primary-btn">Explore Jobs</Link>
      </section>

      {/* Featured Jobs Section */}
      <section className="featured-jobs">
        <h2>🔥 Featured Job Openings</h2>
        <div className="job-list">
          <div className="job-card">
            <h3>Software Engineer</h3>
            <p>Google - Remote</p>
            <p className="salary">₹15 LPA</p>
            <Link to="/jobs/1" className="apply-btn">Apply Now</Link>
          </div>
          <div className="job-card">
            <h3>Data Scientist</h3>
            <p>Amazon - Bangalore</p>
            <p className="salary">₹20 LPA</p>
            <Link to="/jobs/2" className="apply-btn">Apply Now</Link>
          </div>
          <div className="job-card">
            <h3>Frontend Developer</h3>
            <p>Microsoft - Hyderabad</p>
            <p className="salary">₹12 LPA</p>
            <Link to="/jobs/3" className="apply-btn">Apply Now</Link>
          </div>
        </div>
        <Link to="/jobs" className="btn secondary-btn">View All Jobs</Link>
      </section>

      {/* Career Tips Section */}
      <section className="career-tips">
        <h2>📚 Career Tips & Resources</h2>
        <p>Get expert guidance on resumes, interviews, and upskilling.</p>
        <Link to="/careertips" className="btn primary-btn">Explore Career Tips</Link>
      </section>

      {/* About Us Section */}
      <section className="about-us">
        <h2>🌟 Why Choose Us?</h2>
        <ul>
          <li>✔ 10,000+ job listings across various domains</li>
          <li>✔ Expert career advice & interview prep</li>
          <li>✔ Resume-building guidance & job alerts</li>
          <li>✔ Free & paid courses to upskill</li>
        </ul>
      </section>

      {/* Call to Action */}
      <section className="cta">
        <h2>🎯 Ready to Land Your Dream Job?</h2>
        <p>Sign up now to get personalized job recommendations.</p>
        <Link to="/signup" className="btn primary-btn">Get Started</Link>
      </section>
    </div>
  );
};

export default Home;
